import { useEffect, useState } from "react";
import {
  sanitizeLocation,
  themeHasDefaultStyles,
} from "../../../../../services/Utils";
import { createThemeResource } from "./createThemeResource";
import { loadThemePrices } from "../../../../../services/EncarteThemeService";

/**
 * Fetch a theme by location and return theme state.
 * @param {string} token - Auth token
 * @param {string} modelUrl - The encarte theme model URL
 * @returns {object} { theme, loading }
 */
export default function useFetchTheme({
  token,
  encarte,
  setIsEncarteUpdating,
}) {
  const [model, setModel] = useState(null);

  useEffect(() => {
    if (!encarte || !encarte.modelUrl) {
      setModel(null);
      setIsEncarteUpdating(false);
      return;
    }
    setIsEncarteUpdating(true);
    const fetchTheme = async () => {
      try {
        const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
        const sanitizedLocation = sanitizeLocation(encarte.modelUrl);
        const url = `${BASE_URL}/encartethemes/by-location?location=${encodeURIComponent(sanitizedLocation)}`;
        const res = await fetch(url, {
          headers: { Authorization: token },
        });
        if (res.status === 404) {
          setModel(null);
        } else if (!res.ok) {
          throw new Error("Failed to fetch theme by location");
        } else {
          const result = await res.json();
          let themeResource = await createThemeResource(result, token);
          themeResource = await loadThemePrices(themeResource, token);
          setModel(themeResource);
        }
      } catch (e) {
        setModel(null);
        console.error("Error fetching theme by location:", e);
        setIsEncarteUpdating(false);
      }
      setIsEncarteUpdating(false);
    };
    fetchTheme();
  }, [token, encarte?.modelUrl]);

  return { model, setModel };
}
